import {Pipe, PipeTransform} from '@angular/core';
import {orderBy} from 'lodash';

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {
  transform(array: any, arg1: string, arg2: any): any[] {
    return orderBy(array, arg1, arg2);
  }
}
